<template>
  <div>
    <div v-if="nbCharacters < limit" v-html="contentText"></div>
    <div
      v-else
      class="rc-read-more--wrapper"
      :class="{
        'rc-read-more--open': isReadMoreOpen,
        'rc-bg-dark': dark
      }"
      :style="cssNbLines"
    >
      <div class="rc-read-more--text" v-html="contentText"></div>
      <div class="rc-read-more--button" aria-hidden="true">
        <button
          class="btn btn-link"
          :class="{
            'btn-show-more': isReadMoreOpen,
            'btn-show-less': !isReadMoreOpen
          }"
          @click="onReadMoreClick"
        >
          <span v-if="!isReadMoreOpen"
            >{{ $t("common.show_more")
            }}<RcIcon name="chevronDownBold" scale=".6"></RcIcon
          ></span>
          <span v-if="isReadMoreOpen">
            {{ $t("common.show_less")
            }}<RcIcon name="chevronUpBold" scale=".6"></RcIcon>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import RcIcon from "@/libvue/components/icons/Base.vue";
export default {
  name: "RcReadMore",
  components: {
    RcIcon
  },
  props: {
    contentText: {
      type: String,
      default: ""
    },
    limit: {
      type: Number,
      default: 400
    },
    nbLines: {
      type: Number,
      default: 4
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  emits: ["readMoreOpened"],
  data() {
    return {
      isReadMoreOpen: false
    };
  },

  computed: {
    cssNbLines() {
      return {
        "--rc-nb-lines": `${this.nbLines}`
      };
    },
    nbCharacters() {
      let txtArea = document.createElement("textarea");
      //Remove html balises
      txtArea.innerHTML = this.contentText.replace(/<[^>]*>/g, "");
      //Clean special characters
      let cleanText = txtArea.value;

      return cleanText.length;
    }
  },
  methods: {
    onReadMoreClick() {
      this.isReadMoreOpen = !this.isReadMoreOpen;
      this.$emit("readMoreOpened", this.isReadMoreOpen);
    }
  }
};
</script>

<style lang="scss">
.rc-read-more {
  &--wrapper {
    --rc-nb-lines: 4;
    .rc-read-more--text {
      width: 100%;
      display: -webkit-box;
      -webkit-line-clamp: var(--rc-nb-lines);
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      color: black;

      p {
        margin-bottom: 0;

        //To correct bug in Safari
        &:not(:first-child) {
          display: none;
        }
      }
    }

    &.rc-read-more--open {
      .rc-read-more--text {
        display: block;
        -webkit-line-clamp: unset;
        -webkit-box-orient: unset;
        overflow: visible;
        text-overflow: unset;

        p {
          margin-bottom: 1rem;

          &:not(:first-child) {
            display: block;
          }
        }
      }
      .rc-read-more--button {
        .btn {
          margin-top: 0;
        }
      }
    }
  }

  &--button {
    .btn {
      margin-top: 0.625rem;
      color: black;
    }
  }
}

.rc-bg-dark {
  .rc-read-more {
    &--text {
      color: white;
    }
    &--button {
      .btn {
        color: white;
      }
    }
  }
}
</style>
